import { useLocation } from "@gatsbyjs/reach-router"

export function useIsBillingFormScreen() {
  const location = useLocation()

  return location?.pathname.includes(`/dashboard/pricing/`)
}
